module.exports = __webpack_public_path__ + "img/favor.dfad132f.png";